import { IconMetronome, IconVinyl } from '@tabler/icons-react';
import classNames from 'classnames';

import s from "./livekit.module.scss";
import { AudioControlsContext, AudioControlsProvider } from './audio-controls-provider';
import { WebAudioProvider } from './web-audio-provider';
import { Tab, Tabs } from '@shared/ui/tabs/tabs';
import { SynchronizedAudioPlayer } from './synchronized-audio-player/synchronized-audio-player';
import { Metronome } from './metronome/metronome';

/** Вкладки «музыка / метроном». Должны быть отрендерены внутри AudioControlsProvider. */
export const PluginsTabs = ({ className }) => {
	return (
		<AudioControlsContext.Consumer>
			{({stopMusic}) => (
				<Tabs className={classNames(s.tabs, className)} onChange={stopMusic} options={[
					{label: <IconVinyl/>, key: 'tab-1'},
					{label: <IconMetronome/>, key: 'tab-2'},
				]}>
					<Tab key={'player'}>
						<SynchronizedAudioPlayer/>
					</Tab>
					<Tab key={'metronome'}>
						<Metronome/>
					</Tab>
				</Tabs>
			)}
		</AudioControlsContext.Consumer>
	)
}

export const Plugins = () => {
	return (
		<div className={s.pluginsWrapper}>
			<WebAudioProvider>
			<AudioControlsProvider>
				<PluginsTabs/>
			</AudioControlsProvider>
		</WebAudioProvider>
		</div>
	)
}
